module.exports = __webpack_public_path__ + "media/public/img/logo-ab69f6fb50320c5b225c76a69d11143b.png";